import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { GTMService } from '@services';
import { InstallationFeaturesStore } from '@store';
import {
  Feature,
  FeatureActionFields,
  FeatureCommands,
  FeatureNames,
  FeaturePropertyKey,
  HeatingCoolingCircuitRemoteDefrostCommands,
  HeatingCoolingCircuitRemoteDefrostProperties,
} from '@vi-iot/client/index';
import { BannerType } from 'src/app/shared/components/banner/banner.model';

@Component({
  selector: 'app-defrosting-remote-trigger',
  templateUrl: './defrosting-remote-trigger.component.html',
  styleUrl: './defrosting-remote-trigger.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefrostingRemoteTriggerComponent implements OnChanges {
  @Input({ required: true }) feature: Feature<
    HeatingCoolingCircuitRemoteDefrostProperties,
    HeatingCoolingCircuitRemoteDefrostCommands
  >;

  readonly BannerType = BannerType;

  defrostProcessFinished = false;

  constructor(
    public installationFeaturesStore: InstallationFeaturesStore,
    private gtmService: GTMService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.feature.previousValue?.properties.active.value === true &&
      changes.feature.currentValue?.properties.active.value === false
    ) {
      this.defrostProcessFinished = true;
    }
  }

  triggerOneTimeDefrost(): void {
    this.installationFeaturesStore.updateFeature(
      FeatureNames.heatingCoolingCircuitsRemoteDefrost,
      true,
      FeaturePropertyKey.active,
      FeatureActionFields.active,
      FeatureCommands.setActive
    );
    this.gtmService.track('onConfirm', 'Manual Defrost', 'Refrigant Circuit');
  }

  cancelOneTimeDefrost(): void {
    this.gtmService.track('onCancel', 'Manual Defrost', 'Refrigant Circuit');
  }
}
